// Script para detectar e destacar color-swatch selecionado
document.addEventListener('DOMContentLoaded', function() {
  
  // Função para atualizar a borda do swatch selecionado
  function updateSelectedSwatch() {
    // Remove a classe 'selected' de todos os swatches
    document.querySelectorAll('.color-swatch').forEach(swatch => {
      swatch.classList.remove('selected');
    });
    
    // Adiciona a classe 'selected' ao swatch cujo input está marcado
    document.querySelectorAll('.color-swatch input[type="radio"]:checked').forEach(radio => {
      const swatch = radio.closest('.color-swatch');
      if (swatch) {
        swatch.classList.add('selected');
        
        // Log para debug - mostra qual variante foi selecionada
        console.log('Variante selecionada:', {
          nome: radio.name,
          valor: radio.value,
          elemento: swatch
        });
      }
    });
  }
  
  // Executa ao carregar a página
  updateSelectedSwatch();
  
  // Adiciona listener para mudanças nos radio buttons
  document.querySelectorAll('.color-swatch input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', function() {
      updateSelectedSwatch();
      
      // Informação adicional sobre a seleção
      console.log('Nova seleção:', this.value);
    });
  });
  
  // Observer para detectar mudanças dinâmicas no DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
        updateSelectedSwatch();
      }
    });
  });
  
  // Observa mudanças nos inputs
  document.querySelectorAll('.color-swatch input[type="radio"]').forEach(radio => {
    observer.observe(radio, { attributes: true });
  });
});